import React from 'react'
import cx from 'classnames'
import Footer from 'components/Layouts/Footer'
import Logo from '@components/Layouts/Logo'
import styles from './index.scss'

type IProps = {
    isModal?: boolean
    children?: React.ReactNode
    width?: number
}

const PreLoginLayout = (props: IProps) => {
    const { isModal = false, children, width } = props
    return (
        <div className={cx(styles['pre-login-layout'], { [styles.isModal]: isModal })}>
            {!isModal && <Logo />}
            <div className={styles.content} style={{ width }}>
                {children}
            </div>
            {!isModal && <Footer />}
        </div>
    )
}

export default PreLoginLayout
